import React from 'react';
import './index.css';
import img from '../../../images/img/Diabetes.png'
import img2 from '../../../images/img/Elderly.jpg'
import img3 from '../../../images/img/slider2.jpg'
import { Link } from 'react-router-dom';

const Service = () => {
    return (
        <section className="container" style={{marginTop: 100, marginBottom:100}}>
            <div className='mb-5 section-title text-center'>
                <h2>Services</h2>
                <p className='m-0'>WRCHospital provides a comprehensive range of services to meet your healthcare needs.</p>
            </div>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-4 col-sm-6">
                        <div className="service-img">
                            <img src={img} alt="" className="img-fluid" />
                            <img src={img2} alt="" className="img-fluid mt-4" />
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-6">
                        <div className="service-img mt-4 mt-lg-0">
                            <img src={img3} alt="" className="img-fluid" />
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="service-content ps-4 mt-4 mt-lg-0">
                            <h2>Personal care <br />healthy living</h2>
                            <p className="mt-4 mb-5 text-secondary form-text" style={{ textAlign: 'justify' }}>At WRCH, we're dedicated to providing top-tier medical care to our community. With a focus on innovation and compassion, we're committed to delivering excellence in healthcare, ensuring the well-being of all those we serve.</p>
                            <Link to={'/service'} className="btn-get-started scrollto">Services</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Service